"use strict";

exports.__esModule = true;
exports.formatInterval = formatInterval;
exports.formatIntervalForTickets = formatIntervalForTickets;
function formatInterval(_ref) {
  var startMillis = _ref.startMillis,
    endMillis = _ref.endMillis;
  return new Date(startMillis).toISOString() + "/" + new Date(endMillis).toISOString();
}
function formatIntervalForTickets(_ref2) {
  var startMillis = _ref2.startMillis,
    endMillis = _ref2.endMillis;
  return new Date(startMillis).toISOString() + ";" + new Date(endMillis).toISOString();
}